export default __webpack_public_path__ + "static/genre_04-6a8b0a11edbeccae007777d9815aee24.png";